var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPatternHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1134,
    height: 1134,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#747B95",
    opacity: 0.25,
    cx: 567,
    cy: 567,
    r: 355.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#747B95",
    opacity: 0.25,
    cx: 567,
    cy: 567,
    r: 566.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#747B95",
    opacity: 0.25,
    cx: 567,
    cy: 567,
    r: 282.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88 549)",
    fill: "#D8DAE0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 596,
    cy: 354,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 336,
    r: 9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternHeader);
export default __webpack_public_path__ + "static/media/bg-pattern-header.d3afcf03347d6367f4cbf75972801c48.svg";
export { ForwardRef as ReactComponent };